import type { ReactNode } from 'react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Add } from '@mui/icons-material';
import { Button } from 'components/mui/common/Button';

interface Props {
  onClick: () => void;
  disabled?: boolean;
  children?: ReactNode;
  dataTestId?: string;
}

export const AddButton = memo(({ onClick, disabled, children, dataTestId }: Props) => {
  const { t } = useTranslation();

  return (
    <Button variant="outlined" startIcon={<Add />} onClick={onClick} disabled={disabled} data-testid={dataTestId}>
      {children ?? t('common.add')}
    </Button>
  );
});
